import { render, staticRenderFns } from "./TheForm.vue?vue&type=template&id=9a1c8afa&scoped=true"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"
import style0 from "./TheForm.vue?vue&type=style&index=0&id=9a1c8afa&prod&scoped=true&lang=css"
import style1 from "./TheForm.vue?vue&type=style&index=1&id=9a1c8afa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1c8afa",
  null
  
)

export default component.exports